import axios from "axios"
import { IPersonnelArretMaladieModel } from "@common-models/*"
import { CONST_API_PERSONNEL_DECLARATION_MALADIE_CREATE_ENDPOINT } from "../../../../../endpoints"
import { ICreateConnectedPersonnelMaladieRequestModel } from "./_models"
import {
     CONST_PERSONNEL_ARRET_MALADIE_MOTIF_ARRET_THERAPEUTIQUE,
     CONST_PERSONNEL_ARRET_MALADIE_MOTIF_MALADIE,
     CONST_PERSONNEL_ARRET_MALADIE_TYPE_TYPE_AUTRE,
     CONST_PERSONNEL_ARRET_MALADIE_TYPE_TYPE_JOUR,
} from "@common-constants/*"

export function createConnectedPersonnelMaladieRequest(payload: ICreateConnectedPersonnelMaladieRequestModel) {
     const formData = new FormData()
     formData.append("data[du]", payload.du as string)

     if (
          payload.motif === CONST_PERSONNEL_ARRET_MALADIE_MOTIF_MALADIE ||
          (payload.motif === CONST_PERSONNEL_ARRET_MALADIE_MOTIF_ARRET_THERAPEUTIQUE &&
               (payload.type === CONST_PERSONNEL_ARRET_MALADIE_TYPE_TYPE_JOUR || payload.type === CONST_PERSONNEL_ARRET_MALADIE_TYPE_TYPE_AUTRE))
     ) {
          formData.append("data[au]", payload.au as string)
     }

     formData.append("data[motif]", payload.motif!)
     if (payload.type) formData.append("data[type]", payload.type)
     if (payload.justificatif) formData.append("justificatif", payload.justificatif)
     return axios.post<IPersonnelArretMaladieModel>(CONST_API_PERSONNEL_DECLARATION_MALADIE_CREATE_ENDPOINT, formData)
}
